import ClickToRevealHost from 'components/clickToReveal/ClickToRevealHost';
import FlashcardsHost from 'components/flashCards/FlashcardsHost';
import {parseConfig as parseClickToReveal} from 'lib/clickToReveal/parseConfig';
import {parseConfig as parseFlashCards} from 'lib/flashCards/parseConfig';

// The code half of each unit island's hydration — the React component and its
// parse adapter, keyed by custom-element tag. The serializable half (className,
// plus any future static config) lives in islands.json so Ruby reads it too.
// bindings.spec.js asserts the two cover exactly the same tags.
//
// flash-cards and legacy thc-flash-cards share one host so published units keep
// working while Badge Builder emits the new tag. Remove legacy hydrate + thc.js
// flash CEs when backpacks catch up: W-24349760.
export const BINDINGS = {
  'click-to-reveal': {component: ClickToRevealHost, parse: parseClickToReveal},
  'flash-cards': {component: FlashcardsHost, parse: parseFlashCards},
  'thc-flash-cards': {component: FlashcardsHost, parse: parseFlashCards}
};
